
import { Component, Prop, toNative, Vue } from 'vue-facing-decorator';
import NotificationPopup from '@/components/Common/NotificationPopup.vue';
import { ApplicationViewModel } from '@/entities/Application/ApplicationViewModel';
import { NavBarImages } from '@/entities/Application/NavBarImages';
import ModuleTypeEnum from '@/enums/ModuleTypeEnum';
import { EventSideMenu } from '@/entities/Application/EventSideMenu';
import { AppNavBarImages } from '@/entities/Application/AppNavBarImages';
import { ApplicationSideMenu } from '@/entities/Application/ApplicationSideMenu';

@Component({
  components: {
    NotificationPopup,
  },
})
class LeftMenuPanel extends Vue {
  @Prop() viewModel!: ApplicationViewModel;
  @Prop() showLeftMenuBar!: boolean;
  @Prop() menuItems!: EventSideMenu | ApplicationSideMenu;
  @Prop() iconImages!: NavBarImages | AppNavBarImages;
  @Prop() activeComponent!: string;
  private IconFile: string = require('@/assets/Images/VentlaLogo/Ventla-Logo-Grey.svg');
  private currentYear: number = new Date().getUTCFullYear();

  public get routeParams() {
    return {
      applicationborderColor: this.viewModel.ApplicationInformation.TopNavBackgroundColor,
      applicationId: this.viewModel.ApplicationInformation.Id,
      applicationInstanceId: this.viewModel.ActiveEvent.Id,
    };
  }

  public get selectedComponent(): typeof ModuleTypeEnum {
    return ModuleTypeEnum;
  }

  private GetImageSrc(id: number, isActive: boolean) {
    return isActive ? this.iconImages.NavBarImage[id].ActiveImageSrc : this.iconImages.NavBarImage[id].ImageSrc;
  }

  // Helper to ensure external URLs are formatted correctly
  private GetFullExternalUrl(url: string) {
    if (!url) {
      return 'javascript:void(0)';
    }
    // Prepend Environment URL if it's a relative path
    const baseUrl = (this as any).$EnvironmentBaseURL;
    return url.startsWith('http') ? url : baseUrl + url;
  }

}
export default toNative(LeftMenuPanel);

